export const state = {
	crypto_id_list: [],
	skrill_id_data: [],
	neteller_id_data: [],
	userProfile: [],

	ticketList: [],
	dashboardData: {},
	ticketView: [],
	ticketReasonList: [],
	ticketData: [],

	countriesList: [],
	citiesList: [],

	//dashboard
	ChartData: [],
	tradingAccountList: {},


	//ib
	ibList: [],
	ibDetail: [],

	//client
	catList: [],
	articleList: [],
	tradAccountDetail: [],
	userList: [],
	userView: [],
	userCount: [],

	//deposit
	depositList: [],
	depositView: [],

	//bonus
	bonusList: [],
	bonusView: [],

	//withdrawal
	withdrawalList: [],
	withdrawalCommList: [],
	affiliateCommList: [],
	withdrawalView: [],
	withdrawalMethodResponse: [],
	withdrawalMethodResponse: [],
	withdrawalMethodResponseDep: [],
	withdrawalMethod: { '1': 'bank_transfer', '2': 'skrill', '3': 'neteller', '5': 'CreditCardVias', '6': "Giropay", '7': "przelewy-24", '8': "rapid-transfer", '9': 'Nordea', '10': 'Klarna' },

	//trading
	tradingList: [],
	ibtradingList: [],
	tradingView: [],
	userCommission: {},

	// user sub ib list
	subIbList: [],

	//==========================================================================================================================
	department_list: [
		{ 'id': '4', 'description': 'Sales', 'role': 'SL' },
		{ 'id': '5', 'description': 'Customer Support', 'role': 'CS' },
		{ 'id': '6', 'description': 'Back Office', 'role': 'BO' },
		{ 'id': '7', 'description': 'Accounts', 'role': 'AC' },
		{ 'id': '8', 'description': 'IT', 'role': 'IT' },
		{ 'id': '9', 'description': 'Demat Department', 'role': 'DP' },
		{ 'id': '3', 'description': 'Reporting Manager', 'role': 'RM' },
	],

	currency: { 'EUR': 'eur.svg', 'USD': 'usd.svg', 'GBP': 'gbp.svg', 'CHF': 'chf.svg', 'JPY': 'jpy.svg', 'AUD': 'aud.svg' },
	depositMethod: { '1': 'Bank', '2': 'Skrill', '3': 'Neteller' },
	depositStatus: { '0': 'pending', '1': 'success' },

	bonusType: { '1': 'Add Bonus', '2': 'Remove Bonus' },
	bonusStatus: { '0': 'open', '1': 'processed' },

	demoLive: { '0': 'demo', '1': 'live' },
	proUsers: { '0': 'no', '1': 'yes', 0: 'no', 1: 'yes' },

	withdrawalType: { '1': 'Withdrawal', '2': 'Internal Transfer' },

	withdrawalStatus: { '0': 'open', '1': 'processed', '2': 'rejected' },

	stepsText: { '0': "Initiated", '1': "On Personal", '2': 'On Finacial', '3': "On Test", '4': 'Declaration', '5': 'Completed' },

	withdrawalMethods: { '1': 'bank_transfer.png', '2': 'skrill.png', '3': 'neteller.png' },
	//ticketDocsLink : "https://app.fxview.com:2087/get/docs?type=",
	dashboardLink1: "https://app.fxview.com/register?refLink=",
	//dashboardLink2 : "https://dev.finvasia.com:8082/register?refLink=",
	//dashboardLink2 : "https://dev.finvasia.com:8082/register?refLink=",

	ticketDocsLink: "https://ib.portfolios.com:2096/get/docs?type=",
	dashboardLink2: "https://ib.portfolios.com/register?refLink=",
	genderList: { 'M': 'male', 'F': 'female' },



	empStatus: { '01': 'Employed', '02': 'Self-Employed', '03': 'Unemployed', '04': 'Student', '05': 'Retired' },
	occupation: { '01': 'Director', '02': 'Head/Manager of a Department', '03': 'Partner', '04': 'Office Manager', '05': 'Admin/Secretarial', '06': 'Professional Staff', '07': 'Accountant', '08': 'Caretaker', '09': 'Other' },
	estYearlyIncome: { '01': '< 25k', '02': '25k - 50k', '03': '50k - 100k', '04': '100k - 250k', '05': '250k - 500k', '06': '> 500k' },
	estNetWorth: { '01': '< €25k ', '02': '€25k - €50k ', '03': '€50k - €100k ', '04': '€100k  - €250k ', '05': '€250k  - €500k ', '06': '> €500k ' },
	antAccountTurnover: { '01': '€0 - €10k', '02': '€10k - €50k', '03': '€50k -€100k', '04': '€100k - €250k', '05': '€250k - €500k', '06': '€500k +' }
}



// WEBPACK FOOTER //
// ./src/plugins/fxView/provider/candle-history/store-addons/state.js